import { api } from "../../axios";

export const actions = {
    CreateAccount(context, data) {
        return api.post("Account", data);
    },
    Login(context, data) {
        return api.post("Account/login", data);
    },
    Logout() {
        return api.post("Account/logout");
    },
    ChangePassword(context, data) {
        return api.post("Account/changePassword", data);
    },
    ChangeEmail(context, data) {
        return api.put(`Account/Email/${data.id}`, data);
    },
    ChangePhoneNumber(context, data) {
        return api.put(`Account/Phone/${data.id}`, data);
    },
    VerifyPhoneNumber() {
        return api.post(`Account/Phone/Confirmation/`);
    },
    PhoneNumberVerification(context, data) {
        return api.post(`Account/Phone/Verify?code=${data}`);
    },
    ForgotPassword(context, data) {
        return api.post(`Account/ForgotPassword`, data);
    },
    VerifyForgotPassword(context, data) {
        return api.post(`Account/ForgotPassword/Verify`, data);
    },
    GetProfile() {
        return api.get("Account/MyProfile");
    },
    SendEmailCode(text, data){
        return api.post(`Account/Email/Code/Send?email=${data.email}`, );
    },
    VerifyEmailCode(text, data){
        return api.post("Account/Email/Code/Verify?userId=" + data.applicationUserId + "&code=" + data.code);
    },
}